import { Button, Checkbox, Col, Card, Form, Input, Row, Collapse, Select, notification, Modal, Table, Space, theme, Tabs } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined, SettingOutlined, ArrowLeftOutlined, UserOutlined, VideoCameraOutlined } from "@ant-design/icons";
import { Fragment, useEffect, useRef, useState } from "react";
import * as animationData from "../serviceanim.json";
import Lottie from "react-lottie";
import { validateEmail } from "../utils/methods";
import axios from "axios";
import { API_ENDPOINT } from "../api/endPoint";
import { useNavigate } from "react-router-dom";
import CreateServiceRequest from "./CreateServiceRequest";
import SRList from "./srlist";
import UserAddresses from "./UserAddresses";
import Profile from "./Profile";
import { CustomersScreen } from "./CustomersScreen";

const Dashboard = () => {
  const { useToken } = theme;
  const { token } = useToken();

  const [api, contextHolder] = notification.useNotification();
  const [user, setUser] = useState(null); // <-- Store the user object here
  const [currentTab, setCurrentTab] = useState("1");
  const [tabName, setTabName] = useState("Create");
  const [existingSR, setExistingSR] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/login");
      return;
    }
    getUserDetails();
  }, []);

  const getUserDetails = async () => {
    try {
      const response = await axios.get(API_ENDPOINT + "/users/detail");
      if (response.data.user) {
        setUser(response.data.user); // <-- store the whole user
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Called when SRList triggers edit
  const handleSREdit = (item) => {
    setTabName("Edit");
    setExistingSR(item);
    setCurrentTab("2"); // Switch to edit tab
  };

  // Build tab items dynamically based on user state
  const items = [
    {
      key: "1",
      label: "Previous Service Requests",
      children: <SRList onSREdit={handleSREdit} />,
    },
  ];

  if (user?.isCreatingEnabled) {
    items.push({
      key: "2",
      label: tabName,
      children: <CreateServiceRequest serviceRequest={existingSR} />,
    });

    items.push({
      key: "3",
      label: "Customers",
      children: <CustomersScreen />,
    });
  }

  return (
    <Fragment>
      <Col span={24}>
        <div style={{ textAlign: "end", marginRight: "15px" }}>
          <a
            onClick={() => {
              localStorage.removeItem("token");
              navigate("/");
            }}
            style={{ color: "#ae9572", fontWeight: "bold" }}
          >
            Logout
          </a>
        </div>

        <Tabs type="card" centered activeKey={currentTab} items={items} onChange={(key) => setCurrentTab(key)} />
      </Col>
    </Fragment>
  );
};

export default Dashboard;
